export enum ZIndex {
  MOBILE_TOP_BAR = 8500,
  SELECT_MENU = 8900,
  SLIDING_PANEL = 9000,
}
